
import { defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    components: { Cheap },
    props: {
        index: {
            type: Number,
            default: 1,
        },
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    setup() {
        const getClass = (status_id: number) => {
            return status_id === 22 ? 'yellow' : status_id === 23 ? 'green' : ''
        }

        return { getClass }
    },
})
